import { connect } from "react-redux";
import get from "lodash/get";

import {
  getJobRequests as onGetJobRequests,
  setJobRequestsFilter as onSetJobRequestsFilter,
  createJobRequest as onCreateJobRequest,
  deleteJobRequest as onDeleteJobRequest,
  selectJobRequest as onSelectJobRequest,
} from "./../../actions/jobRequestActions";

const mapStateToProps = (state) => ({
  jobRequestsDataState: state.jobRequests.jobRequestsDataState,
  createJobRequestsDataState: state.jobRequests.createJobRequestsDataState,
  deleteJobRequestsDataState: state.jobRequests.deleteJobRequestsDataState,
  jobRequestsFilter: get(state, ["jobRequests", "jobRequestsFilter"], {
    jobRequestType: -1,
    isWinter: false,
  }),
  jobRequestsFull: get(state, ["jobRequests", "jobRequestsFull"], []),
  jobRequests: get(state, ["jobRequests", "jobRequests"], []),
  selectJobRequest: get(state, ["jobRequests", "selectJobRequest"], null),
});

const mapDispatchToProps = { onGetJobRequests, onSetJobRequestsFilter, onCreateJobRequest, onDeleteJobRequest, onSelectJobRequest };

const withJobRequests = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withJobRequests };
